import {
  DEFAULT_PARTNER_ID,
  DEFAULT_PUBLIC_WALL,
  DEFAULT_WALL_ID,
} from "../cards/cardConstants";

export const DEFAULT_REFINE_CONTEXT = {
  partnerId: "",
  wallId: "",
  partnerName: "",
  displayLabel: "LettuceTalk",
  shareAttribution: "LettuceTalk",
  analyticsLabel: "Individual",
};

// Partner URLs pass a stable partner slug; the registry owns the Firestore wall
// IDs so visitors cannot choose arbitrary wall IDs through query params.
export const MCAAD_REFINE_CONTEXT = {
  partnerId: DEFAULT_PARTNER_ID,
  wallId: DEFAULT_WALL_ID,
  partnerName: "MCAAD",
  displayLabel: "LettuceTalk x MCAAD",
  shareAttribution: "LettuceTalk × MCAAD",
  analyticsLabel: "MCAAD",
};

export const MCAAD_REFINE_PATH = "/refine?partner=mcaad";
export const MCAAD_WALL_REFINE_PATH = `/refine?wallId=${DEFAULT_WALL_ID}`;

const REFINE_CONTEXTS_BY_PARTNER = {
  mcaad: MCAAD_REFINE_CONTEXT,
};

export function getRefineContextFromSearch(searchParams) {
  const partnerId = searchParams.get("partner");
  const partnerContext = REFINE_CONTEXTS_BY_PARTNER[partnerId];

  if (!partnerContext) {
    return DEFAULT_REFINE_CONTEXT;
  }

  return partnerContext;
}

function getCleanString(value) {
  return typeof value === "string" && value.trim() ? value.trim() : "";
}

export function getWallIdFromSearch(searchParams) {
  return getCleanString(searchParams.get("wallId"));
}

export function getRefineContextFromWall(wall) {
  if (!wall?.id) {
    return null;
  }

  if (wall.id === DEFAULT_WALL_ID) {
    return {
      ...MCAAD_REFINE_CONTEXT,
      partnerId: getCleanString(wall.partnerId) || DEFAULT_PARTNER_ID,
      wallId: wall.id,
    };
  }

  const title = getCleanString(wall.title);
  const eyebrow = getCleanString(wall.eyebrow);
  const partnerId = getCleanString(wall.partnerId);
  const label = eyebrow || title || "Community Wall";

  return {
    ...DEFAULT_REFINE_CONTEXT,
    partnerId,
    wallId: wall.id,
    partnerName: partnerId,
    displayLabel: label,
    shareAttribution: label,
    analyticsLabel: title || wall.id,
  };
}

export function getDefaultWallRefineContext() {
  return getRefineContextFromWall(DEFAULT_PUBLIC_WALL);
}
